import { 
    distanceBetweenDots, 
    distanseBetweenLayers, 
    getCenteredCoordinateForAnimation, 
    getNotCenteredCoordinateForAnimationByAngle, 
    BallPositionByDot,
    parabolic,
    JUMP_FROM_DOT_TO_DOT_ANIMATION_TIME
 } from '../../initials';
export class JumpFromDotToDotStartTopRightEndCenter {
    constructor({
        fromRowIndex,
        fromDotIndex,
        toRowIndex,
        toDotIndex,
        dots,
    }) {
        this.fromRowIndex = fromRowIndex;
        this.fromDotIndex = fromDotIndex;
        this.toRowIndex = toRowIndex;
        this.toDotIndex = toDotIndex;
        this.dots = dots;
    }

    static getAnimationSettings() {
        return {
            avaiableForMultipleLevels: false,
            type: 'JumpFromDotToDotStartTopRightEndCenter',
            fromBallPositionByDot: BallPositionByDot.TOP_RIGHT,
            toBallPositionByDot: BallPositionByDot.CENTER,
        };
    }

    getAnimationTime() {
        return JUMP_FROM_DOT_TO_DOT_ANIMATION_TIME;
    }

    animate(time) {
        const fullTime = this.getAnimationTime();
        const t = time / fullTime;

        const isLeftMovement = this.fromDotIndex >= this.toDotIndex;

        const startDot = this.dots[this.fromRowIndex][this.fromDotIndex];
        const endDot = this.dots[this.toRowIndex][this.toDotIndex];

        const startXY = getNotCenteredCoordinateForAnimationByAngle(startDot.dotX, startDot.dotY, Math.PI / 4);
        const endXY = getCenteredCoordinateForAnimation(endDot.dotX, endDot.dotY)

        return {
            x: parabolic(
                startXY.x, 
                isLeftMovement ? startXY.x - distanceBetweenDots / 2 : startXY.x + distanceBetweenDots / 2, 
                endXY.x, 
                t,
            ),
            y: parabolic(
                startXY.y, 
                startXY.y - distanseBetweenLayers / 2, 
                endXY.y, 
                t,
            ),
        };
    };
};